import { heroStory } from "@/mocks/stories";

export default function Hero() {
  const h = heroStory;
  return (
    <section id="top" className="scroll-mt-24 border-b border-secondary-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1240px] gap-8 px-4 py-8 md:px-6 md:py-12 lg:grid-cols-12 lg:gap-10">
        <div className="flex flex-col lg:col-span-7">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            {h.kicker}
          </div>

          <h1 className="font-heading mt-4 text-3xl font-black leading-[1.22] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.18]">
            {h.headline}
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
            {h.dek}
          </p>

          <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-secondary-600">
            <span className="inline-flex items-center gap-1.5 font-semibold text-foreground-800">
              <i className="ri-newspaper-line text-sm text-primary-600" />
              {h.source}
            </span>
            <span className="hidden h-3 w-px bg-secondary-300 sm:block" />
            <span className="inline-flex items-center gap-1">
              <i className="ri-time-line text-sm" />
              {h.updatedAt}
            </span>
            <span className="hidden h-3 w-px bg-secondary-300 sm:block" />
            <span className="inline-flex items-center gap-1 text-foreground-600">
              <i className="ri-eye-line text-sm" />
              {h.views}
            </span>
            <span className="inline-flex items-center gap-1 text-foreground-600">
              <i className="ri-chat-3-line text-sm" />
              {h.comments}
            </span>
          </div>

          <div className="mt-5 flex flex-wrap gap-2">
            {h.tags.map((t) => (
              <span
                key={t}
                className="whitespace-nowrap rounded-full border border-secondary-200 bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700"
              >
                #{t}
              </span>
            ))}
          </div>

          <div className="mt-7 rounded-lg border border-secondary-200 bg-background-100 p-4 md:p-5">
            <p className="mb-3 flex items-center gap-2 text-xs font-bold tracking-widest text-foreground-800">
              <span className="h-3.5 w-1 rounded-sm bg-primary-500" />
              证据链速览 · 主编导读
            </p>
            <ul className="space-y-2.5">
              {h.points.map((p, i) => (
                <li key={p} className="flex items-start gap-2.5 text-sm leading-6 text-foreground-700">
                  <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-secondary-200 text-[11px] font-bold text-foreground-800">
                    {i + 1}
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-center lg:col-span-5">
          <div className="relative h-[420px] w-full overflow-hidden rounded-xl md:h-[560px] lg:h-auto lg:min-h-[560px]">
            <img
              src="https://readdy.ai/api/search-image?query=dark%20editorial%20tabloid%20newspaper%20collage%20background%20in%20near-black%20ink%2C%20bold%20torn%20paper%20pieces%20with%20heavy%20black%20redaction%20bars%20and%20scattered%20white%20newspaper%20type%20fragments%2C%20a%20stylized%20glowing%20magnifying%20glass%20at%20the%20center%20casting%20warm%20light%2C%20moody%20high-contrast%20magazine%20cover%20art%2C%20textured%20print%20grain%2C%20warm%20amber%20and%20crimson%20accents%2C%20abstract%2C%20no%20people%2C%20no%20readable%20text%2C%20dramatic%20centered%20composition&width=900&height=1120&seq=hei-liao-hero-2026-01&orientation=portrait"
              alt="黑料录音门发酵追踪头条配图"
              title="录音门发酵追踪头条配图"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-4 pt-12">
              <p className="flex items-center gap-2 text-sm font-semibold text-background-50">
                <span className="h-px w-6 bg-primary-400" />
                图 · 还原现场｜顾言川「录音门」
              </p>
            </div>
            <span className="absolute right-3 top-3 grid place-items-center rounded-md bg-foreground-950/70 px-2.5 py-1 text-[11px] font-bold text-background-50 backdrop-blur">
              现场影像
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-200 bg-background-50">
        <div className="mx-auto flex w-full max-w-[1240px] flex-wrap items-center gap-x-8 gap-y-3 px-4 py-3 text-xs text-secondary-600 md:px-6">
          <span className="font-bold tracking-widest text-foreground-800">同步在追</span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            顾言川工作室二更声明后，粉丝团反应两极
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            导师站姿复盘帖阅读量突破 30 万
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-400" />
            节目组送检回执疑似流出
          </span>
          <span className="ml-auto hidden items-center gap-1.5 font-medium text-primary-600 md:inline-flex">
            全部跟进
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </div>
      </div>
    </section>
  );
}